import {createReducer, on} from '@ngrx/store';
import {NaseDialogState} from '../states/nase-dialog.state';
import {NaseDialogActions} from '../actions/nase-dialog.actions';

export const initialNaseDialogState: NaseDialogState = {
  isOpen: false,
};

export const naseDialogReducer = createReducer(
  initialNaseDialogState,
  on(NaseDialogActions.open, state => ({
    ...state,
    isOpen: true,
  })),
  on(NaseDialogActions.close, state => ({
    ...state,
    isOpen: false,
  })),
);
